export const TOUR_DESTINATION_IN_DEMAND_START = "TOUR_DESTINATION_IN_DEMAND_START";
export const TOUR_DESTINATION_IN_DEMAND_SUCCESS = "TOUR_DESTINATION_IN_DEMAND_SUCCESS";
export const TOUR_DESTINATION_IN_DEMAND_ERROR = "TOUR_DESTINATION_IN_DEMAND_ERROR";

export const TOP_TOUR_PARNERS_START = "TOP_TOUR_PARNERS_START";
export const TOP_TOUR_PARNERS_SUCCESS = "TOP_TOUR_PARNERS_SUCCESS";
export const TOP_TOUR_PARNERS_ERROR = "TOP_TOUR_PARNERS_ERROR";

export const TOUR_RECOMMANDED_BIKES_START = "TOUR_RECOMMANDED_BIKES_START";
export const TOUR_RECOMMANDED_BIKES_SUCCESS = "TOUR_RECOMMANDED_BIKES_SUCCESS";
export const TOUR_RECOMMANDED_BIKES_ERROR = "TOUR_RECOMMANDED_BIKES_ERROR";